import React,{Component} from 'react';

import {
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand
} from 'reactstrap';


import GloatingCreamsicle from '../../../shared/assets/gloating-creamsicle.png';

class TutorialLoadingScreen extends Component {
  render(){
    return (
      <div
        style={{
          position:'fixed',
          left:0,
          right:0,
          top:0,
          bottom:0,
          backgroundColor:'#ffffff',
          zIndex:1000
        }}
      >
        <Navbar
          toggleable
          style={{
            padding:'0px 30px 0px 30px',
            color:'#101010',
            borderBottom:'',
            height:70
          }}
          className='HorizontalNavBar no-print'
        >
          <NavbarBrand>
            <img
              src={require('../../../shared/assets/dd-logo.png')}
              alt='Adjoy'
              style={{height:30,marginRight:10}}
            />
          </NavbarBrand>
        </Navbar>
        <Container>
          <Row>
            <Col xs='12'>
              <div className='OnboardingTutorialSetup'>
                <div id='chat-widget' />
                <img
                  src={GloatingCreamsicle}
                  alt='Gloating creamsicle'
                />
                <br />
                <br />
                <h5>{this.props.title}</h5>
                <p>{this.props.subtitle}</p>
                <br />
                {this.props.showSpinner && (
                  <i className="fa fa-spinner fa-spin fa-3x" />
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default TutorialLoadingScreen;



// WEBPACK FOOTER //
// ./src/shared/components/TutorialLoadingScreen/index.js